export const IS_PRODUCTION = import.meta.env.VITE_IS_PRODUCTION === 'true'
